import { AlertInfo, CheckBox, PrimaryButton } from '@tricor-digital-team/vistra-design-system';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateFormData } from '../Redux/formSlice';
import { useDispatch } from 'react-redux';

const DisclaimerForm = () => {
  const dispatch = useDispatch();

  const [read, setRead] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(false);
  const navigate = useNavigate();
  const handleNextPage = (e) => {
    e.preventDefault();
    // Perform any validations or data updates here
    navigate('/stepperform');
  };
  return (
    <div className="w-full mt-12 max-w-[807px] flex flex-col items-center justify-center">
      <div className="bg-white shadow-xl rounded-2xl w-full py-12 px-[103px]">
        <div>
          <div className="text-4xl font-normal">Companies House Identity Verification Service</div>
          <div className="text-base mt-6">
            To improve transparency and build confidence in UK companies, the Economic Crime and Corporate Transparency
            Act requires all{' '}
            <span className="font-bold">
              directors, LLP members, Persons with Significant Control (PSC) and individuals who file on behalf of
              Companies
            </span>{' '}
            to have their identity verified and registered with Companies House, securing a personal code for that individual.
            <br />
            <br />
            If a corporate director or entity is listed as a PSC (Relevant Legal Entity), provide details for at least one director of that corporate entity for identity verification.
            <br />
            <br />
            The personal code is linked to the individual, not their role or the corporate entity. Therefore, if someone is both a director and a PSC, or a director of multiple companies, they’ll {' '}
            only need to submit one application.
            {/* <span className="font-bold"></span> */}
          </div>
          <div className="text-2xl mt-12 font-normal">How much will it cost</div>
          <div className="flex flex-col items-center justify-center rounded-lg mt-4 px-6 py-4 w-full font-normal text-sm border border-gray-400">
            <span className="font-medium text-2xl">£200</span>
            <span>+VAT per individual Companies House Identity Verification</span>
          </div>
          <div className="text-base mt-6">
            This fee covers access to our digital identity verification platform, along with support from our dedicated
            team of experts as needed. It also includes the required application to Companies House for the Personal code, which will be issued directly to the individual named in the application.
            <br />
            <br />
            In the event that identity cannot be verified on first attempt, one additional attempt is included in the
            fee. However, if it's not possible to complete identity verification on the second attempt, a new
            application must be made, and an additional fee will apply.
          </div>
          <div className="text-2xl mt-12 font-normal">How to apply</div>
          <div className="text-base mt-4">
            On the following pages, you’ll be asked to provide some basic information of the individual(s) requiring
            Vistra’s Companies House Verification Service. For each individual, have the following details ready:
            <br />
            <br />
            <ul className="list-disc pl-5">
              <li>Full name</li>
              {/* <li>12 months of address history</li>
              <li>Date of birth and contact email address.</li> */}
              <li>Contact email address.</li>
            </ul>
          </div>
          <div className="text-xl my-12 font-normal">
            <AlertInfo info>
              <div className="text-base">
                You must make a separate application for each entity that you support but you can request{' '}
                <span className="font-bold">up to ten verifications per entity</span>. If the entity you're supporting
                have more than ten individuals requiring this service, contact our{' '}
                <a
                  href="mailto:bulkeccta@vistra.com"
                  className="text-blue-800 underline font-medium"
                >
                  support team
                </a>.
              </div>
            </AlertInfo>
          </div>
          <CheckBox
            handleOnChange={(e) => setRead(e.target.checked)}
            size="large"
            label={
              <div className="text-base">
                I have read and agree to the{' '}
                <a
                  href="https://www.vistra.com/idv-terms/uk"
                  className="text-blue-800 underline font-medium"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms and conditions
                </a>{' '}
                and{' '}
                <a
                  href="https://www.vistra.com/privacy-notice"
                  className="text-blue-800 underline font-medium"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy policy
                </a>
                .
              </div>
            }
          />
          <div className='mt-3'>
            <CheckBox
              handleOnChange={(e) => setAllowMarketing(e.target.checked)}
              size="large"
              label={
                <div className="text-base">
                  I agree to receive marketing communications from Vistra.
                </div>
              }
            />
          </div>
          <div className="mt-12">
            <PrimaryButton
              label="Let's start"
              disabled={!read}
              onClick={(e) => {
                e.preventDefault();
                dispatch(updateFormData({ 'allowMarketingCommunication': allowMarketing }))
                handleNextPage(e);
              }}
              size="large"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default DisclaimerForm;
